import React from 'react';
import { BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import { SignIn, Dashboard } from './pages';
import * as ROUTES from './constants/routes';
import { IsUserRedirect, ProtectedRoute } from './helpers/routes';
import { useAuthListener } from './hooks';

export function App() {
  const { user } = useAuthListener();

  return (
    <Router>
      <Switch>
        <ProtectedRoute user={user} path={ROUTES.DASHBOARD} exact>
          <Dashboard />
        </ProtectedRoute>
        <IsUserRedirect user={user} loggedInPath={ROUTES.DASHBOARD} path={ROUTES.SIGN_IN} exact>
          <SignIn />
        </IsUserRedirect>
        <Redirect to={user ? ROUTES.DASHBOARD : ROUTES.SIGN_IN} />
      </Switch>
    </Router>
  );
}
